import { render, staticRenderFns } from "./SpecAiIndicator.vue?vue&type=template&id=4d554c91&scoped=true&lang=pug&"
import script from "./SpecAiIndicator.vue?vue&type=script&lang=js&"
export * from "./SpecAiIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SpecAiIndicator.vue?vue&type=style&index=0&id=4d554c91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d554c91",
  null
  
)

export default component.exports